export type SummaryType =
  | "mentionedParties"
  | "topicRelevance"
  | "thingBeingProcured"
  | "contractValue"
  | "bidRequirements";

export const ORDER_OF_SECTIONS_ON_PAGE: SummaryType[] = [
  "thingBeingProcured",
  "contractValue",
  "topicRelevance",
  "mentionedParties",
  "bidRequirements",
];

export type SummaryValue = {
  content: string | null;
  attributeName: SummaryType;
};

export const ATTRIBUTE_NAMES: Record<SummaryType, string> = {
  contractValue: "Contract structure",
  topicRelevance: "Tech stack mentioned",
  bidRequirements: "Supplier requirements",
  mentionedParties: "Organisations mentioned",
  thingBeingProcured: "Product / service",
};
